import type { SupportTranslations } from './types'

export const arTranslations: SupportTranslations = {
  title: 'تذاكر الدعم',
  subtitle: 'إدارة طلبات الدعم للعملاء والداخلية',
  newTicket: 'تذكرة جديدة',
  createForbidden: 'ليس لديك صلاحية لإنشاء تذكرة دعم، اطلب من المسؤول إضافة الصلاحية',
  getHelp: 'احصل على المساعدة',
  submitTicket: 'إرسال تذكرة',
  submit: 'إرسال التذكرة',

  statusOpen: 'مفتوحة',
  statusInProgress: 'قيد التنفيذ',
  statusWaiting: 'بانتظار المبلّغ',
  statusResolved: 'تم الحل',
  statusClosed: 'مغلقة',

  priorityLow: 'منخفضة',
  priorityMedium: 'متوسطة',
  priorityHigh: 'عالية',
  priorityUrgent: 'عاجلة',

  channelCustomer: 'العملاء',
  channelInternal: 'داخلي',
  allChannels: 'جميع القنوات',
  filterChannel: 'القناة',

  categoryOrder: 'مشكلة في الطلب',
  categoryDelivery: 'مشكلة في التوصيل',
  categoryPayment: 'مشكلة في الدفع',
  categoryAccount: 'مشكلة في الحساب',
  categoryBug: 'خلل في المنصة',
  categoryHardware: 'عطل في الأجهزة',
  categoryFeature: 'طلب ميزة',
  categoryGeneral: 'عام',
  categoryOther: 'أخرى',

  statsOpen: 'مفتوحة',
  statsInProgress: 'قيد التنفيذ',
  statsResolved: 'تم الحل',
  statsTotal: 'الإجمالي',

  colTicket: 'رقم التذكرة',
  colSubject: 'الموضوع',
  colChannel: 'القناة',
  colCategory: 'الفئة',
  colPriority: 'الأولوية',
  colStatus: 'الحالة',
  colCreated: 'تاريخ الإنشاء',
  colSla: 'اتفاقية الخدمة',
  slaMet: 'تم الالتزام باتفاقية الخدمة',
  slaBreached: 'تم خرق اتفاقية الخدمة',
  slaOutcome: 'نتيجة اتفاقية الخدمة',
  slaSelect: 'هل تم الالتزام باتفاقية الخدمة؟',
  slaOpenFor: 'مفتوحة منذ',
  slaTarget: 'المستهدف',
  slaDue: 'الاستحقاق',
  slaSuggestMet: 'ضمن المدة المستهدفة — الاقتراح: تم الالتزام',
  slaSuggestBreached: 'تجاوزت المدة المستهدفة — الاقتراح: تم الخرق',

  fieldFactory: 'المصنع',
  selectFactory: 'اختر المصنع',
  fieldSubject: 'الموضوع',
  fieldCategory: 'الفئة',
  fieldPriority: 'الأولوية',
  fieldDescription: 'الوصف',
  fieldEmail: 'البريد الإلكتروني',
  fieldPhone: 'رقم الهاتف',
  fieldAttachments: 'الصور',
  subjectPlaceholder: 'ملخص موجز لمشكلتك',
  selectCategory: 'اختر الفئة',
  descriptionPlaceholder: 'صف مشكلتك بالتفصيل...',
  emailPlaceholder: 'email@example.com',
  phonePlaceholder: '+966 5X XXX XXXX',
  attachmentsHint: 'حمّل حتى 5 صور (بحد أقصى 10 ميجابايت لكل صورة)',
  attachmentsRequired: 'يلزم إرفاق صورة واحدة على الأقل',
  removePhoto: 'إزالة الصورة',
  addPhoto: 'اضغط لإضافة صور',
  addPhotoFormats: 'JPG و PNG و WEBP و GIF',
  fileTooLarge: 'يجب أن يكون حجم الملفات أقل من 10 ميجابايت',
  photo: 'صورة',
  photos: 'صور',
  submittingAs: 'يتم الإرسال باسم',
  submitting: 'جاري الإرسال...',

  searchPlaceholder: 'البحث في التذاكر...',
  filterByStatus: 'تصفية حسب الحالة',
  selectStatus: 'اختر الحالة',
  noTickets: 'لم يتم العثور على تذاكر دعم',

  tabOverview: 'نظرة عامة',
  tabNotes: 'الملاحظات',
  tabTimeline: 'السجل الزمني',
  timelineCreated: 'تم فتح التذكرة',
  timelineNoteAdded: 'تمت إضافة ملاحظة',
  noTimeline: 'لا يوجد نشاط بعد',
  none: 'لا شيء',
  value: {
    open: 'مفتوحة',
    in_progress: 'قيد المعالجة',
    waiting_on_reporter: 'بانتظار مقدم الطلب',
    resolved: 'تم الحل',
    closed: 'مغلقة',
    low: 'منخفضة',
    medium: 'متوسطة',
    high: 'عالية',
    urgent: 'عاجلة',
    met: 'تم الالتزام بالاتفاقية',
    breached: 'تم خرق الاتفاقية',
    order_issue: 'مشكلة طلب',
    delivery_issue: 'مشكلة توصيل',
    payment_issue: 'مشكلة دفع',
    account_issue: 'مشكلة حساب',
    platform_bug: 'خلل في المنصة',
    malfunctioning_hardware: 'عطل في الأجهزة',
    feature_request: 'طلب ميزة',
    general: 'عام',
    other: 'أخرى',
    customer_to_spcc: 'عميل',
    spcc_to_525k: 'داخلي',
    customer_portal: 'بوابة العملاء',
    ecommerce_app: 'تطبيق المتجر',
    admin_portal: 'بوابة الإدارة',
    gate_portal: 'بوابة البوابة',
    kiosk_portal: 'بوابة الكشك',
  },
  assignedTo: 'مسند إلى',
  unassigned: 'غير مسند',
  tenant: 'المستأجر',
  resolvedAt: 'تاريخ الحل',
  updateStatus: 'تحديث الحالة',

  noNotes: 'لا توجد ملاحظات بعد',
  addNote: 'إضافة ملاحظة',
  notePlaceholder: 'أضف ملاحظة...',

  exportReport: 'تصدير التقرير',
  exportPreparing: 'جارٍ إعداد التقرير...',
  exportSuccess: 'تم تنزيل التقرير',
  exportError: 'تعذر إنشاء التقرير',
  exportEmpty: 'لا توجد تذاكر مطابقة للمرشحات الحالية',
  exportTruncated: 'تم تحديد التقرير — قم بتضييق المرشحات للحصول على تقرير كامل',
  reportSheetSummary: 'الملخص',
  reportSheetTickets: 'التذاكر',
  reportColMetric: 'المؤشر',
  reportColValue: 'القيمة',
  reportColPercent: 'النسبة %',
  reportGeneratedAt: 'تاريخ الإنشاء',
  reportFiltersApplied: 'المرشحات المطبقة',
  reportFiltersNone: 'لا يوجد — جميع التذاكر',
  reportTotalTickets: 'إجمالي التذاكر',
  reportBreachRate: 'معدل خرق اتفاقية مستوى الخدمة',
  reportAvgResolutionHours: 'متوسط زمن الحل (ساعة)',
  reportMedianResolutionHours: 'وسيط زمن الحل (ساعة)',
  reportByStatus: 'حسب الحالة',
  reportByPriority: 'حسب الأولوية',
  reportByCategory: 'حسب الفئة',
  reportByChannel: 'حسب القناة',
  colDescription: 'الوصف',
  colSourcePortal: 'بوابة المصدر',
  colResolutionHours: 'زمن الحل (ساعة)',
  colSlaTarget: 'المستهدف (ساعة)',
  colOverdue: 'متأخرة',
  colNotes: 'الملاحظات',
  yes: 'نعم',
  no: 'لا',

  createSuccess: 'تم إنشاء تذكرة الدعم بنجاح',
  updateSuccess: 'تم تحديث تذكرة الدعم بنجاح',
  createError: 'فشل في إنشاء تذكرة الدعم',
  updating: 'جارٍ التحديث...',
  customerSupportTitle: 'الدعم',
  customerSupportSubtitle: 'احصل على المساعدة بشأن طلباتك وتسليماتك وحسابك',
  myTickets: 'تذاكري',
  noMyTickets: 'ليس لديك أي تذاكر دعم حتى الآن',
}
